<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :tableHeight="tableHeight"
      @reload="reload"
      @chooseFabric="chooseFabric"
      @choose-change="(r) => $emit('choose-change', r)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
      </PageHeader>

      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import { request } from '@/api/service'
export default {
  props: {
    tableHeight: { type: Number, default: 300 },
    url: {
      type: String,
      default: '/digitalCenter/customer/proofing/sample/detail/choose',
    },
    extrasParams: { type: Object, default: () => ({}) },
  },
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader },
  data() {
    return { usePage: true, checkedRows: [] }
  },
  methods: {
    getData(form) {
      this.loading = true
      request({
        url: this.url,
        method: 'POST',
        data: { ...form, ...this.page, ...this.extrasParams },
      })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    chooseFabric(data) {
      this.$emit('chooseFabric', data)
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
